export enum FilterControlConstants {
  OptionsThrottleWait = 300,
  FreeSearchDebounceWait = 500
}
